import { Marker } from 'google-maps-react';
import { resolvePin, PIN_SIZE } from '../pinResolver';

function SearchChannelMarkers({
    google,
    searchActive,
    searchClusterMode,
    showPublicChannels,
    tempChannels,
    markerTypes,
    onMarkerClick,
    searchRefs,
}) {
    if (!searchActive || searchClusterMode || !showPublicChannels || !tempChannels) return null;

    return tempChannels.map((channelData, channelIndex) => {
        if (!channelData?.addresses?.[0]) return null;

        // Deduplicate addresses by lat/lng to prevent stacked flickering pins
        const seen = new Set();
        const uniqueAddresses = channelData.addresses.filter((address) => {
            if (!address?.latitude || !address?.longitude) return false;
            const key = `${address.latitude.toFixed(6)},${address.longitude.toFixed(6)}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });

        return uniqueAddresses.map((channel, index) => (
            <Marker
                key={`${channelData.id}_${index}`}
                title={channelData.title}
                name={channelData.subTitle}
                id={channelData.id}
                icon={{
                    url: resolvePin(channelData, markerTypes).url,
                    scaledSize: new google.maps.Size(PIN_SIZE.width, PIN_SIZE.height),
                }}
                onClick={onMarkerClick}
                position={{
                    lat: channel?.latitude,
                    lng: channel?.longitude,
                }}
                teamData={channelData.teamData}
                activeEvents={channelData.activeEvents}
                className="mapp"
                ref={(element) => (searchRefs.current[channelIndex] = element)}
            />
        ));
    });
}

export default SearchChannelMarkers;
